import $ from 'jquery';
import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

$(() => {
  const homeSwiper = new Swiper('.home-swiper', {
    loop: true,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    modules: [Autoplay, Navigation, Pagination],
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
});
